"use client";

import React, { useState, useCallback, useEffect, useMemo } from "react";
import SingleProductSlider from "./SingleProductSlider";
import SingleProductInfo from "./SingleProductInfo";
import ArDesktopPrompt from "./ArDesktopPrompt";
import { useProductAr } from "@/lib/hooks/useProductAr";
import { getProductImagesWithMeta } from "@/lib/utils/product";

export default function ProductGallery({ product }) {
  const [swiper, setSwiper] = useState(null);
  const productImages = useMemo(() => getProductImagesWithMeta(product), [product]);
  const [selectedColor, setSelectedColor] = useState(null);
  const { hasArModel, handleArClick, showArPrompt, setShowArPrompt } = useProductAr(product);

  const handleSlideChange = useCallback((s) => {
    const currentIndex = s.realIndex;
    const currentImage = productImages[currentIndex];
    if (currentImage) {
      const colorCode = currentImage.code || currentImage.color;
      if (colorCode) {
        setSelectedColor(colorCode);
      }
    }
  }, [productImages]);

  const handleColorChange = (colorCode) => {
    if (!swiper || !productImages.length) return;

    const index = productImages.findIndex(
      (img) => (img.code === colorCode || img.color === colorCode)
    );

    if (index !== -1) {
      setSelectedColor(colorCode);
      if (swiper.params.loop) {
        swiper.slideToLoop(index);
      } else {
        swiper.slideTo(index);
      }
    }
  };

  useEffect(() => {
    if (swiper && productImages.length > 0) {
      handleSlideChange(swiper);
    }
  }, [swiper, productImages, handleSlideChange]);

  return (
    <>
      <div className="flex flex-wrap lg:flex-nowrap justify-between gap-5 mb-16 ">
        <div className="flex w-full flex-col gap-4 lg:w-[440px] shrink-0">
          <SingleProductSlider
            images={productImages}
            onSwiper={setSwiper}
            onSlideChange={handleSlideChange}
          />
        </div>
        <SingleProductInfo
          product={product}
          selectedColor={selectedColor}
          onColorChange={handleColorChange}
          arEnabled={hasArModel}
          onArClick={handleArClick}
        />
      </div>

      <ArDesktopPrompt open={showArPrompt} onClose={() => setShowArPrompt(false)} />
    </>
  );
}
